export interface StripeAccount {
    id: ID;
    remoteId: string;
    remoteSystem: string | StripeAccountRemoteSystem;
    verification: string;
    type: string | StripeAccountType;
    business_type?: string;
    data: {
        external_accounts?: { data?: StripeBankAccount[] };
        verification?: {
            disabled_reason: string;
            due_by: number;
        };
        requirements?: {
            currently_due: any;
        };
        future_requirements?: {
            currently_due: any;
        };
    };
}

export enum StripeAccountType {
    STANDARD = "standard",
    CUSTOM = "custom",
}

export enum StripeAccountRemoteSystem {
    STRIPE = "stripe",
}

export interface StripeBankAccount {
    id?: ID;
    currency: string;
    country: string;
    routing_number: string;
    account_number: string;
    last4?: string;
    account_holder_name: string;
    account_holder_type?: string;
}

export interface AccountLink {
    expiresAt: number;
    id: string | null;
    url: string;
}
